var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconGenderMale = function SvgIconGenderMale(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19.25 6.164V8.25a1 1 0 1 0 2 0v-4.5a1 1 0 0 0-1-1h-4.5a1 1 0 1 0 0 2h2.085l-3.358 3.358a7.75 7.75 0 1 0 1.414 1.414zm-5.436 4.021-.038-.04a5.75 5.75 0 1 0 .039.04",
    clipRule: "evenodd"
  })));
};
export default SvgIconGenderMale;